import React, { Component } from 'react';

import BlogHeader from '../BlogHeader';
import styles from './styles.module.less';
import Accent from '../Accent';
import PreviewBlogs from './PreviewBlogs';
import AuthorBlogs from './AuthorBlogs';
import { isBe, imgBrand } from './../../lib/brand';

var beBug = imgBrand(isBe ? 'be-circle-mark.png' : 'rf-circle-mark.png');

class BlogCategory extends Component {
   constructor(props) {
      super(props);

      this.state = {
         loBlogs: {},
         author: ''
      };
   }
   fetchBlogs = async author => {
      const url = `/blog/author/${author}.json`;
      try {
         const response = await fetch(url);
         return response.ok ? await response.json() : [];
      } catch (err) {
         return [];
      }
   };

   componentDidMount = async () => {
      let author = window.location.href.split('author=')[1];
      let loBlogs = await this.fetchBlogs(author);
      this.setState({ loBlogs });
      this.setState({ author });
   };
   render() {
      const { catBlogs, categories, title = categories, heroBug = false } = this.props;
      const { loBlogs, author } = this.state;

      return (
         <section>
            <div className={styles.categoryContainer}>
               <BlogHeader categories={categories} />
               {this.state.loBlogs.length > 0 && <AuthorBlogs blogs={loBlogs} author={author} />}
               <div className={styles.titleContainer}>
                  {heroBug && <img src={beBug} className={styles.headerBug} alt="BEbug" />}
                  <h1 className={styles.title}>{title}</h1>
                  <Accent />
               </div>
               <PreviewBlogs blogs={catBlogs} />
            </div>
         </section>
      );
   }
}

export default BlogCategory;
